<template>
    <div class="PhyStore">
        <!--导航栏-->
        <navbar :transparent="isTransparent" activeTo="Home"></navbar>
        <div class="PhyStore-Content">
            <h1 class="store-title">{{$t('footer_Resellers')}}</h1>
            <Row>
                <i-col :lg="8" :md="8" :sm="12" :xs="24" v-for="(item,index) in StoreList" :key="index">
                    <div class="PhyStore-col" @click="Goshop(item.id)">
                        <div class="PhyStore-wrap">
                            <h1>{{item.name}}</h1>
                            <img :src="item.img">
                            <div class="PhyStore-address">
                                <h3 class="font_mid">{{$t('shop_address')}}：</h3>
                                <p class="font_mid">{{item.address}}</p>
                            </div>
                            <div class="PhyStore-time">
                                <h3 class="font_mid">{{$t('shop_hours')}}：</h3>
                                <div class="font_mid">
                                    <p class="time">
                                        <label>{{$t('monday_friday')}}</label>
                                        <span>10:00 a.m ~ 9:00 p.m</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </i-col>
                <i-col :lg="8" :md="8" :sm="12" :xs="24">
                    <img src="../../assets/coming_soon.jpg" alt=""  class="phystore-img">
                    <p class="phystore-tip">{{$t('iretail_coming_tip')}}</p>
                </i-col>
            </Row>
        </div>
    </div>
</template>
<script>
    import navbar from '../../components/Common/Navbar.vue'
    import Signature from '../../lib/Signature'
    export default {
        data () {
            return {
                isTransparent: false,
                StoreList: []
            }
        },
        components: {
            navbar
        },
        methods:{
            //获取线下门店信息
            GetStoreInfo () {
                const module = 'index.php/offline_store'
                let data = {}
                data.lang = this.$i18n.locale
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                this.$http.get(process.env.BASEURL + module, {params: data})
                    .then(function (response) {
                        console.log(response.data)
                        this.StoreList = response.data.data
                    }.bind(this))
            },

            //跳转门店详情
            Goshop (id) {
                this.$router.push(
                    {
                        name:'Shop',
                        query:{
                            id : id
                        }
                    }
                )
            }
        },
        created (){
            //获取线下门店信息
            this.GetStoreInfo ()
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../scss/_phystore.scss";
</style>



// WEBPACK FOOTER //
// PhysicalStore.vue?c3380746